const initSideCartUpsells = () => {
  const initSideCartSlider = () => {
    const el = document.querySelector(".side-cart-upsells .splide");
    if (!el) return;

    const sideCartSplide = new Splide(el, {
      type: "slide",
      arrows: false,
      pagination: false,
      perPage: 1.3,
      perMove: 1,
      gap: 16,
      drag: true,
      focus: 0,
      breakpoints: {
        500: {
          perPage: 1.2,
          gap: 9,
        },
      },
    });

    var bar = sideCartSplide.root.querySelector(
      ".side-cart-upsells_progress-bar",
    );
    var barContainer = sideCartSplide.root.querySelector(
      ".side-cart-upsells_progress",
    );

    // Updates the bar width whenever the carousel moves:
    sideCartSplide.on("mounted move", function () {
      var end = sideCartSplide.Components.Controller.getEnd() + 1;
      var rate = Math.min((sideCartSplide.index + 1) / end, 1);
      bar.style.width = String(100 * rate) + "%";
    });

    sideCartSplide.mount();

    barContainer.setAttribute(
      "count",
      sideCartSplide.Components.Slides.getLength(),
    );

    window.sideCartInstance.initializeAddToCartFormsPartial(el);
  };

  const cartDrawer = document.querySelector("side-cart");

  if (cartDrawer) {
    const observer = new MutationObserver(() => {
      if (cartDrawer.classList.contains("open")) {
        setTimeout(() => {
          initSideCartSlider();
        }, 200);
      }
    });

    observer.observe(cartDrawer, {
      attributes: true,
      attributeFilter: ["class"],
    });
  }
};

export { initSideCartUpsells };
